// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconHome } from '@tabler/icons';

const icons = {
    IconHome
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
    id: 'dashboard',
    title: <FormattedMessage id="dashboard" />,
    icon: icons.IconHome,
    type: 'group',
    url: 'dashboard',
    roles: ['admin', 'cs-others', 'cs-technical', 'ca']
};

export default dashboard;